module.exports = __webpack_public_path__ + "static/media/Thumbnail.e72df17a.jpeg";